import React, { useState, useEffect } from "react";
import "../../../css/admin.css";
import { useDispatch } from "react-redux";
import { EventDetailRestrictions } from "../../../actions/auth";
import { MY_PROFILE } from "../../../actions/types";
const RestrictionsContent = ({ id }) => {
  const dispatch = useDispatch();
  const [restrictionsData, setRestrictionsData] = useState({});
  useEffect(() => {
    dispatch(EventDetailRestrictions(id)).then((res) => {
      if (res.success) {
        setRestrictionsData(res.data);
      }
    });
  }, []);
  return (
    <div className="restrictionsContent">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-12 col-12">
            <div className="RestrictContent">
              <p>Distance radio:</p>
              <p className="restrictHead">
                {restrictionsData && restrictionsData.distance}
              </p>
            </div>
            <div className="RestrictContent">
              <p>Age:</p>
              <p className="restrictHead">
                <div className="row">
                  <div className="col-lg-4 md-6 sm-12">
                    <p className="restrictHead">
                      {" "}
                      From:{restrictionsData && restrictionsData.min_age_range}
                    </p>
                  </div>
                  <div className="col-lg-4 md-6 sm-12">
                    <p className="restrictHead">
                      {" "}
                      To:{restrictionsData && restrictionsData.max_age_range}
                    </p>
                  </div>
                </div>
              </p>
            </div>
            <div className="RestrictContent">
              <p>Gender:</p>
              <div className="d-flex">
              <p className="restrictHead me-4">
                Women: <br />
                {restrictionsData && restrictionsData.ratio_women}%
              </p>
              <p className="restrictHead me-4">
                Men: <br /> {restrictionsData && restrictionsData.ratio_men}%
              </p>
              <p className="restrictHead">
                Other: <br />{" "}
                {restrictionsData && restrictionsData.ratio_others}%
              </p>
              </div>
            </div>

            <div className="RestrictContent">
              <p className="mb-3">Lifestyle</p>
              <ul>
                <li>
                  <a href="#" className="restrictLinks">
                    {restrictionsData.drinking == 1
                      ? "Alcoholic"
                      : "Non Alcoholic"}
                  </a>
                </li>
                <li>
                  <a href="#" className="restrictLinks">
                    {restrictionsData.drugs == 1 ? "Drugists" : "Non Drugist"}
                  </a>
                </li>
                <li>
                  <a href="#" className="restrictLinks">
                    {restrictionsData.smoking == 1 ? "Smoking" : "No smoking"}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-12">
            <div className="RestrictContent customInvitesBox">
              <p>Custom invites</p>
              <p class="restrictHead">Who can see the event</p>
              {restrictionsData.invite_users &&
                restrictionsData.invite_users.map((rr) => {
                  return (
                    <div className="profileWrapp mb-2">
                      <img
                        src={`${MY_PROFILE}/${rr.profile_image}`}
                        onError={(e) => {
                          e.target.onerror = null; // Prevent infinite loop if fallback also fails
                          e.target.src = "/img/noImage.png"; // Updated path to fallback image
                        }}
                        alt="profile"
                        className="invitesProfile"
                      />
                      <div>
                        <h4>{rr.firstname}</h4>
                        <p>{rr.email}</p>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-12">
            <div className="RestrictContent customInvitesBox" style={{ marginTop: 29 }}>
              <h3> </h3>
              <h3> </h3>
              <p class="restrictHead">Who can not see the event</p>
              {restrictionsData.notinvited_users &&
                restrictionsData.notinvited_users.map((rr) => {
                  return (
                    <div className="profileWrapp mb-2">
                      <img
                        src={`${MY_PROFILE}/${rr.profile_image}`}
                        alt="profile"
                        className="invitesProfile"
                        onError={(e) => {
                          e.target.onerror = null; // Prevent infinite loop in case `noImage.png` also fails
                          e.target.src = "img/noImage.png"; // Fallback image if loading fails
                        }}
                      />
                      <div>
                        <h4>{rr.firstname}</h4>
                        <p>{rr.email}</p>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RestrictionsContent;
